<script setup lang="ts">
import { EHubProvider } from '@/types/enum/HubProviderEnum'
import type { CheckpointModel } from '@/types/models/CheckpointModel'
import type { AssociatedDeviceModel } from '@/types/models/DeviceModel'
import type { EventModel } from '@/types/models/EventModel'
import { EProviders, EUserPermission } from '@rfc/rfc-components-library/types'
import { computed, provide, ref } from 'vue'
import { useStore } from 'vuex'

const store = useStore()
const event = ref()
const handleChangeEvent = (value?: EventModel) => (event.value = value)

const checkpoint = ref()
const handleChangeCheckpoint = (value?: CheckpointModel) => (checkpoint.value = value)

provide(EHubProvider.EVENT, { event, handleChangeEvent })
provide(EHubProvider.CHECKPOINT, { checkpoint, handleChangeCheckpoint })

const device = ref()
const handleChangeDevice = (value?: AssociatedDeviceModel) => (device.value = value)

provide(EProviders.QUERY, { deviceQuery: { device, handleChangeDevice } })

const isViewerOnly = computed(() =>
    store?.state.authentication.me?.permissions.includes(EUserPermission.VIEWER)
)
provide(EHubProvider.IS_VIEWER_ONLY, isViewerOnly)
</script>

<template>
    <slot />
</template>
